import { GroupTypeEnum } from '@/types/schema';

export interface GroupDetailProps {
  groupId: string;
  type: GroupTypeEnum;
}

export enum UserGroupsActions {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export enum ActionDialog {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export enum DialogActions {
  Add = 'ADD',
  Remove = 'REMOVE',
  Close = 'CLOSE',
}

export enum GroupDetailsActions {
  BulkExport = 'BULK_EXPORT',
  BulkImport = 'BULK_IMPORT',
}
